class ShopifyStorefrontHelper {
 constructor(key, options) {
 this.key = 'productJSONStore';
 this.productKeys = ['title', 'description'];
 this.variantKeys = ['title', 'price', 'compare_at_price', 'inventory_quantity'];

 if (typeof key === 'string') {
 this.key = key;
 }

 if (typeof options?.productKeys === 'array') {
 this.productKeys = options.productKeys;
 }

 if (typeof options?.variantKeys === 'array') {
 this.variantKeys = options.variantKeys;
 }
 }

 static variantAvailable(variant) {
 return !(variant.inventory_management && variant.inventory_policy.toLowerCase() === 'deny' && variant.inventory_quantity <= 0);
 }

 productCacheKey() {
 const prefix = (window?.Shopify?.routes?.root || '').replaceAll('/', '');
 return prefix ? `${prefix}:${this.key}` : this.key;
 }

 getProductURL(handle) {
 const root = window?.Shopify?.routes?.root || '/';
 return `${root}products/${handle}.js`;
 }

 async getProductJSON(handle) {
 let data = JSON.parse(sessionStorage.getItem(this.productCacheKey()));

 if (data && data[handle]) {
 return data[handle];
 } else {
 const productURL = this.getProductURL(handle);
 return await this.getStorefrontProduct(productURL).then(product => {
 this.saveProductJSON(product);
 return product;
 });
 }
 }

 saveProductJSON(product) {
 let data = JSON.parse(sessionStorage.getItem(this.productCacheKey()));

 if (data == null) {
 data = {};
 }

 if (product) {
 data[product.handle] = product;
 }

 sessionStorage.setItem(this.productCacheKey(), JSON.stringify(data));
 }

 removeProductJSON(handle) {
 let data = JSON.parse(sessionStorage.getItem(this.productCacheKey()));

 if (data == null) {
 data = {};
 }

 if (handle) {
 delete data[handle];
 }

 sessionStorage.setItem(this.productCacheKey(), JSON.stringify(data));
 }

 async getStorefrontProduct(productURL) {
 return fetch(productURL).then((response)=>{ return response.json() });
 }

 updateProductJSON(product, callback = function(){}) {
 this.getProductJSON(product.handle).then(json => {

 // Update product keys
 this.productKeys.forEach(key => {
 product[key] = json[key];
 });

 // Update variants
 product.variants.forEach((variant) => {
 const jsonVariant = json.variants.find(v => v.id == variant.id);

 if (jsonVariant) {
 // Update variant keys
 this.variantKeys.forEach(key => {
 variant[key] = jsonVariant[key];
 });
 }
 });

 // Reset product
 this.initProduct(product);
 
 callback(product);
 });
 }

 initProduct(product) {
 let defaultVariant = product.variants[0];

 for (let i = 0; i < product.variants.length; i++) {
 if (ShopifyStorefrontHelper.variantAvailable(product.variants[i])) {
 defaultVariant = product.variants[i];
 break;
 }
 }

 product.selected_variant = defaultVariant;
 product.selected_variant_id = defaultVariant.id;

 product.option1 = defaultVariant.option1;
 product.option2 = defaultVariant.option2;
 product.option3 = defaultVariant.option3;
 }
}

class TranslationHelper {
 constructor(translationObject) {
 // Allow for global/default translations...
 this.translations = {
 "dk": {
 "smart_cart": {
 "cart_title": "Danish Cart Title!"
 },
 "widget": {
 "add_to_cart": "Danish Add to Cart"
 },
 "12345": {
 "add_to_cart": "Danish Add to Cart (Widget ID: 12345)"
 }
 }
 }

 // Allow for custom instance based translations...
 if (typeof translationObject === 'object' && translationObject !== null) {
 this.translations = translationObject;
 }
 }

 updateSmartCartLanguage() {
 const locale = Shopify?.locale;
 const translation = this.translations[locale]?.smart_cart;

 if (locale && translation) {
 Object.assign(Rebuy.SmartCart.settings.language, translation);
 }
 }

 updateWidgetLanguage(widget) {
 const locale = Shopify?.locale;
 const widgetTranslation = this.translations[locale]?.[widget.id];
 const globalTranslation = this.translations[locale]?.widget;

 if (locale && widgetTranslation) {
 Object.assign(widget.settings.language, widgetTranslation);
 widget.compileConfig();
 } else if (locale && globalTranslation) {
 Object.assign(widget.settings.language, globalTranslation);
 widget.compileConfig();
 }
 }
}

const myTranslationHelper = new TranslationHelper({
 "dk": {
 "smart_cart": {
 "cart_title": "Danish Cart Title!"
 },
 "widget": {
 "add_to_cart": "Danish Add to Cart"
 },
 "12345": {
 "add_to_cart": "Danish Add to Cart (Widget ID: 12345)"
 }
 },
 "fr": {
 "smart_cart": {
 "cart_title": "French Cart Title!"
 },
 "widget": {
 "add_to_cart": "French Add to Cart"
 },
 "12345": {
 "add_to_cart": "French Add to Cart (Widget ID: 12345)"
 }
 }
});

// Update Smart Cart with locale translations
document.addEventListener('rebuy:smartcart.ready', (event) => {
 const helper = new TranslationHelper();

 helper.updateSmartCartLanguage();
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
 const helper = new TranslationHelper();
 const widget = event.detail.widget;

 helper.updateWidgetLanguage(widget);
});

// Update all product & variant information with storefront translations...
document.addEventListener('rebuy.productsChange', (event) => {
 const helper = new ShopifyStorefrontHelper();
 const products = event.detail.widget.data.products;

 products.forEach((product) => {
 helper.updateProductJSON(product);
 });
});
